/**
 * DocumentFormFields Component
 * Common form fields for all document types (title, etc.)
 * Pure presentational component
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from '@mui/material';
import { DocumentFormFieldsProps } from '../types';
import { MAX_TITLE_LENGTH } from '../../../../hooks/documents/uploadQueue';

export const DocumentFormFields: React.FC<DocumentFormFieldsProps> = ({
  title,
  onTitleChange
}) => {
  const { t } = useTranslation();

  return (
    <TextField
      margin="normal"
      required
      fullWidth
      label={t('documents.dialog.title')}
      name="title"
      value={title}
      onChange={onTitleChange}
      slotProps={{
        htmlInput: { maxLength: MAX_TITLE_LENGTH },
      }}
      helperText={`${title.length}/${MAX_TITLE_LENGTH} ${t('common.characters', { defaultValue: 'characters' })}`}
    />
  );
};
